import React from 'react';
import { Section, Header } from 'components';
import { Col, Row  } from 'react-bootstrap';

import styles from './Support.module.css';
import { useTranslation } from 'react-i18next';

type SupportProps = {}

export const Support: React.FC<SupportProps> = React.memo(() => {
  const { t } = useTranslation();
  return (
    <Section>
      <Header className={styles.header} noBackground>
        <Col xs="12" className="col-lg-12"><h2>{t('support')}</h2></Col>
      </Header>
      <Row className={styles.supportInfoCard}>
        <Section>
          <Row><h3>{t('support-info-title')}</h3></Row>
          <Row><p>{t('support-info')}</p></Row>
        </Section>
      </Row>
      <Row>
        <div className={styles.supportCard}>
          <span className={styles.title}>Please Contact Moen Support First</span>
          <p>For installation help and/or technical support</p>
          <span>(USA and Canada)</span>
          <ul>
            <li>1-844-633-8356</li>
            <li><a href='mailto:smarthome@moen.com'>smarthome@moen.com</a></li>
          </ul>
        </div>
      </Row>
    </Section>
  )
});
